import { InvitationsList } from '@/components/InvitationsList';
import { UsersList } from '@/components/UsersList';
import { useOrganization } from '@/hooks/useOrganizations';
import PageSkeleton from '@/layout/Skeleton';

export default function OrganizationUsers() {
  const organization = useOrganization();

  if (!organization?.id) {
    return <div>Organization not found</div>;
  }

  return (
    <PageSkeleton steps={[{ label: 'Organization Users', href: '/users' }]}>
      <div className='max-w-screen-md mx-auto px-4 pt-6 w-full flex flex-col gap-4'>
        <UsersList organizationId={organization.id} />

        <InvitationsList organizationId={organization.id} />
      </div>
    </PageSkeleton>
  );
}
